import React from 'react';

import Page from '../Page/Page';
import Footer, { FooterProps } from '../Theme/Performance/Footer';
import TopBar, { TopBarProps } from '../Theme/Performance/TopBar';
import Header from '../Theme/Header/Header';
import MainFooter from '../Theme/Footer/Footer';

export interface HeaderProps {
    navigation_variant?: string;
    navigation_cta_label?: string | null;
    navigation_cta_link?: string;
    navigation_theme_dark?: boolean;
    navigation_logo_link_home?: boolean;
}
export interface LayoutPerformancePageProps {
    className?: string;
    children: React.ReactNode;
    config?: HeaderProps & {
        footer_links?: FooterProps['links'];
        footer_copyright?: FooterProps['copyright'];
        footer_default?: boolean;
        topbar?: TopBarProps['hasTopbar'];
        topbar_messages?: TopBarProps['messages'];
        topbar_background?: TopBarProps['background'];
        navigation_variant?:
            | 'logo-left'
            | 'default'
            | 'Logo'
            | 'Logo and CTA'
            | 'Logo centered';
        navigation_cta_label?: HeaderProps['navigation_cta_label'];
        navigation_cta_link?: HeaderProps['navigation_cta_link'];
        navigation_theme_dark?: HeaderProps['navigation_theme_dark'];
        navigation_logo_link_home?: HeaderProps['navigation_logo_link_home'];
        navigation_sticky?: boolean;
        navigation_mobile_cta?: boolean;
        navigation_web_cta?: boolean;
    };
}

const LayoutPerformancePage = (props: LayoutPerformancePageProps) => {
    const headerProps = {
        variant: props.config?.navigation_variant,
        sticky: props.config?.navigation_sticky,
        mobileCta: props.config?.navigation_mobile_cta,
        webCta: props.config?.navigation_web_cta,
        darkMode: props.config?.navigation_theme_dark,
        ctaText: props.config?.navigation_cta_label,
        ctaLink: props.config?.navigation_cta_link,
        isPrismic: true,
        logoLinkHome: props.config?.navigation_logo_link_home,
    };
    const footerConfig = {
        links: props.config?.footer_links,
        copyright: props.config?.footer_copyright,
        default: props.config?.footer_default,
    };

    const topBarConfig = {
        hasTopbar: props.config?.topbar,
        messages: props.config?.topbar_messages,
        background: props.config?.topbar_background,
    };

    return (
        <>
            {topBarConfig.hasTopbar ? <TopBar {...topBarConfig} /> : null}
            <Header {...headerProps} />
            <Page className={props.className}>{props.children}</Page>
            {footerConfig.links || footerConfig.copyright ? (
                <Footer {...footerConfig} />
            ) : (
                <MainFooter />
            )}
        </>
    );
};

export default LayoutPerformancePage;
